export enum ProductPricing {
  PerPiece = 'kpl',
  Weight = 'kg',
}
